import React, { useEffect, useState } from "react"
import { View } from "react-native"
import { baseColors } from "@Constants/baseStyles"
import { Button } from "@Components/CustomButton/Button"
import { currentDiagnosisAtom } from "@Recoil/Atom/DiagnosisAtom"
import { useRecoilState } from "recoil"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { ConclusionService } from "@Services/Conclusion.Service"
import { userAtom } from "@Recoil/Atom/userAtom"
import { LocalStorage } from "@Services/sharedPreferences/localStorage"
import { surveyResponsesAtom } from "@Recoil/Atom/surveyAtom"
import { useNavigation } from "@react-navigation/native"

const DiagnosticConclusionFooter = ({ canValidate, fetching, conclusion }) => {
    const navigation = useNavigation()
    const [currentEducationalDiagnosis, setCurrentEducationalDiagnosis] = useRecoilState(currentDiagnosisAtom)
    const [user, setUser] = useRecoilState(userAtom)
    const [responseGlobal, setResponseGlobal] = useRecoilState(surveyResponsesAtom)
    const [validating, setValidating] = useState(false)
    const [denying, setDenying] = useState(false)

    const conclusionId = conclusion?.id ?? 0

    const handleAcceptConclusion = () => {
        if (conclusionId > 0) {
            setValidating(true)
            ConclusionService.acceptDEConclusion({ conclusionId })
                .then(() => {
                    setUser((prev) => ({ ...prev, enteredHealthProfessionals: "" }))
                    navigation.replace("DiagnosticFinished")
                    ShowToast({
                        type: "success",
                        message: "Conclusion bien acceptée, et vous avez terminé votre DE..."
                    })
                    setCurrentEducationalDiagnosis(null)
                    setResponseGlobal({})
                    LocalStorage.resetSurveyResponse().then(() => {
                        setValidating(false)
                        navigation.replace("DiagnosticFinished")
                    })
                    setValidating(false)
                })
                .catch((err) => {
                    console.log({ error: err })
                    ShowToast({ type: "error", message: "Opération échouée" })
                    setValidating(false)
                })
        }
    }

    const handleDenyConclusion = () => {
        if (conclusionId > 0) {
            setDenying(true)
            ConclusionService.denyDEConclusion({ conclusionId })
                .then((res) => {
                    console.log({ res: res })
                    setDenying(false)
                    navigation.replace("Main")
                    ShowToast({ type: "success", message: "Conclusion refusé" })
                })
                .catch((err) => {
                    console.log({ error: err })
                    setDenying(false)
                    ShowToast({ type: "error", message: "Opération échouée" })
                })
        }
    }

    // if (currentEducationalDiagnosis === null) {
    //     navigation.navigate("Diagnostic")
    // }

    const disableValidate = validating || fetching || !canValidate

    return (
        <View style={{ flexDirection: "row", justifyContent: "space-between", padding: 10 }}>
            <Button
                disabled={denying || validating || fetching}
                loading={denying}
                onPress={handleDenyConclusion}
                text="Refuser"
                width="45%"
                height={40}
                backgroundColor={baseColors.orange.primary}
                labelColor={baseColors.white}
            />
            <Button
                onPress={handleAcceptConclusion}
                disabled={disableValidate}
                loading={validating}
                text={validating ? "Validation..." : "Valider"}
                width="45%"
                height={40}
                backgroundColor={baseColors.green.primary}
                labelColor={"white"}
            />
        </View>
    )
}

export default DiagnosticConclusionFooter
